import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/organisms/Header';
import Button from '../components/atoms/Button';
import Icon from '../components/atoms/Icon';

const OnboardingPage = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (option) => {
    if (option === 'manual') {
      navigate('/profile/setup?mode=manual');
    } else if (option === 'resume') {
      navigate('/profile/setup?mode=resume');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Welcome! Let's Set Up Your Profile
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Choose how you'd like to create your profile
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Manual Entry Option */}
          <div 
            onClick={() => setSelectedOption('manual')}
            className={`bg-white dark:bg-gray-800 rounded-2xl p-8 cursor-pointer transition-all duration-300 border-2 ${
              selectedOption === 'manual' 
                ? 'border-primary shadow-xl scale-105' 
                : 'border-gray-200 dark:border-gray-700 hover:border-primary/50 hover:shadow-lg'
            }`}
          >
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 dark:bg-blue-900/30 rounded-full mb-6">
                <Icon name="edit" size={40} className="text-primary" />
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Manual Entry
              </h2>
              
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Fill out your profile step by step with guided forms
              </p>
              
              <ul className="text-left space-y-3 mb-8">
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">Complete control over your information</span>
                </li>
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">Step-by-step guided process</span>
                </li>
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">No resume required</span>
                </li>
              </ul>
              
              <Button
                onClick={() => handleOptionSelect('manual')}
                variant="primary"
                className="w-full"
              >
                Start Manual Entry
              </Button>
            </div>
          </div>

          {/* Resume Upload Option */}
          <div 
            onClick={() => setSelectedOption('resume')}
            className={`bg-white dark:bg-gray-800 rounded-2xl p-8 cursor-pointer transition-all duration-300 border-2 ${
              selectedOption === 'resume' 
                ? 'border-primary shadow-xl scale-105' 
                : 'border-gray-200 dark:border-gray-700 hover:border-primary/50 hover:shadow-lg'
            }`}
          >
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-100 dark:bg-purple-900/30 rounded-full mb-6">
                <Icon name="upload_file" size={40} className="text-purple-600 dark:text-purple-400" />
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Upload Resume
              </h2>
              
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                Let AI extract your information from your resume
              </p>
              
              <ul className="text-left space-y-3 mb-8">
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">Quick and easy setup</span>
                </li>
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">AI-powered data extraction</span>
                </li>
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">Extracts education, work, projects, skills, certifications</span>
                </li>
                <li className="flex items-start">
                  <Icon name="check_circle" size={20} className="text-green-500 mr-2 mt-0.5" />
                  <span className="text-gray-700 dark:text-gray-300">Review and edit before saving</span>
                </li>
              </ul>
              
              <Button
                onClick={() => handleOptionSelect('resume')}
                variant="primary"
                className="w-full"
              >
                Upload Resume
              </Button>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            You can always update your profile later from your dashboard
          </p>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;
